import { Authorization } from "../Authorization";
import { XRInputHelper } from "../babylon/XRInputHelper";
import { Gtm } from "./Gtm";
import { EnvironmentController } from "../settings/EnvironmentController";
import { MessengerCoreImpl } from "./MessengerCoreImpl";
export class AppControllerImpl {
    constructor(params) {
        this._auth = new Authorization(this);
        // this._envSettings = params.envSettings;
        this.scenesSwitcher = params.scenesSwitcher;
        this._hideScenesCallback = params.hideScenesCallback;
        this._showScenesCallback = params.showScenesCallback;
        this.sdk = params.sdk;
        this.messengerSdk = params.messengerSdk;
        this._showHiddenBroadcasts = params.showHiddenBroadcasts;
        this._showOfflineBroadcasts = params.showOfflineBroadcasts;
        this._showCategoriesSelector = params.showCategoriesSelector;
        this._displayedCategoriesArray = params.displayedCategoriesArray;
        this.gtm = new Gtm(this);
        this.gtm.enabled = params.enableGtm;
        this.environmentController = new EnvironmentController();
        this.messengerCore = new MessengerCoreImpl(params.sdk, params.messengerSdk);
    }
    get inputHelper() {
        return XRInputHelper.getInstance();
    }
    get showOfflineBroadcasts() {
        return this._showOfflineBroadcasts;
    }
    get showHiddenBroadcasts() {
        return this._showHiddenBroadcasts;
    }
    get showCategoriesSelector() {
        return this._showCategoriesSelector;
    }
    get displayedCategoriesArray() {
        return this._displayedCategoriesArray;
    }
    set notificationCenter(ns) {
        this._notificationCenter = ns;
    }
    get notificationCenter() {
        return this._notificationCenter;
    }
    async loginWithPartnerTokenAsync(username, partnerToken, partnerUserId) {
        await this._auth.loginAsUserWithTokenAsync(username, partnerToken, partnerUserId);
    }
    async logoutAsync() {
        await this._auth.logoutAsync();
    }
    hideScenes() {
        this._hideScenesCallback();
    }
    showScenes() {
        this._showScenesCallback();
    }
}
